import {
	NewHistoricalChartButton,
	RenderComponentOrLoading,
	STATUS_ENUM,
} from '@innovyze/stylovyze';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations';
import { getIntegrations } from '../integrations/actions/integrations.actions';
import IntegrationsViewForm from './IntegrationsViewForm';
import NewIntegrationDialog from './NewIntegrationSelector';
import IntegrationCard from './IntegrationCard';
import { IntegrationType } from '../types/integration.types';
import { CardContent, Grid } from '@mui/material';
import { NewModelCardWrapper } from './IntegrationsViewGrid.styles';
import WhatisVaparDialog from '../integrations/vapar/WhatisVaparDialog';

const IntegrationsViewGrid = () => {
	const { t } = useGlobalization();
	const { paginatedIntegrations } = useSelector(getValue).integrations;
	const dispatch = useDispatch();

	const [integrationOpen, setIntegrationOpen] = useState(false);
	const [whatIsVaparOpen, setWhatIsVaparOpen] = useState(false);

	useEffect(() => {
		dispatch(getIntegrations({ type: 'all' }));
	}, []);

	const createIntegrationCard = () => (
		<NewModelCardWrapper>
			<CardContent style={{ height: '100%' }}>
				<NewHistoricalChartButton
					dataCy="new-integration-button"
					disabled={paginatedIntegrations?.integrations?.length == 2}
					onClick={() => setIntegrationOpen(true)}>
					{t('Create New Integration')}
				</NewHistoricalChartButton>
			</CardContent>
		</NewModelCardWrapper>
	);

	const getIntegrationType = (sType: string): IntegrationType => {
		if (
			sType == 'Vapar_Integration' ||
			sType == IntegrationType.Vapar ||
			sType == 'vapar'
		)
			return IntegrationType.Vapar;
		else if (
			sType == 'ItPipes_Integration' ||
			sType == IntegrationType.ITPipes
		)
			return IntegrationType.ITPipes;
		else return IntegrationType.ArcGis;
	};

	return (
		<RenderComponentOrLoading
			loading={paginatedIntegrations?.status !== STATUS_ENUM.SUCCESS}>
			<IntegrationsViewForm>
				<NewIntegrationDialog
					open={integrationOpen}
					onCancel={() => setIntegrationOpen(false)}
					setIntegrationOpen={setIntegrationOpen}
					setWhatIsVaparOpen={setWhatIsVaparOpen}
				/>
				<WhatisVaparDialog
					open={whatIsVaparOpen}
					onCancel={() => setWhatIsVaparOpen(false)}
					setWhatIsVaparOpen={setWhatIsVaparOpen}
				/>
			</IntegrationsViewForm>
			<Grid container spacing={2} direction="row">
				<Grid
					xs={12}
					sm={6}
					md={4}
					lg={3}
					xl={2}
					item
					key={'new-integration-card'}>
					{createIntegrationCard()}
				</Grid>
				{paginatedIntegrations?.integrations?.length !== 0 &&
					paginatedIntegrations?.integrations?.map(integration => (
						<Grid
							xs={12}
							sm={6}
							md={4}
							lg={3}
							xl={2}
							item
							key={integration._id}>
							<IntegrationCard
								key={integration._id}
								type={getIntegrationType(integration.type)}
								id={integration._id}
								lastImportTimestamp={
									integration.lastModifiedTimestamp
								}
								isEnabled={integration.isEnabled}
								isValid={integration.isValid || false}
								name={integration.name}
							/>
						</Grid>
					))}
			</Grid>
		</RenderComponentOrLoading>
	);
};

export default IntegrationsViewGrid;
